import React, { useEffect } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  pdf,
} from "@react-pdf/renderer";

import schoolLogo from "./savationChristLogo.png";
import defaultAvatar from "./studentava.jpg";

/* ============================================================
   SECURE PDF COLOR SYSTEM
============================================================ */

const COLORS = {
  black: "#111111",
  charcoal: "#333333",

  orange: "#f97316",
  orangeDark: "#ea580c",
  orangeLight: "#fff7ed",

  gray: "#6b7280",
  gray2: "#9ca3af",
  gray3: "#d1d5db",
  gray4: "#f3f4f6",

  white: "#ffffff",

  green: "#16a34a",
  greenLight: "#ecfdf5",

  red: "#dc2626",
  blue: "#2563eb",
};


/* ============================================================
   A4 PORTRAIT SECURE DOCUMENT STYLES
============================================================ */

const styles = StyleSheet.create({

/* ============================================================
   PAGE
============================================================ */

page: {

  size: "A4",

  backgroundColor: "#fafafa",

  paddingTop: 20,
  paddingBottom: 18,
  paddingHorizontal: 22,

  fontFamily: "Helvetica",

  fontSize: 9,

  color: COLORS.black,

},



/* ============================================================
   HEADER
============================================================ */

header: {

 backgroundColor: "#b8babc",

  borderRadius: 8,

  padding: 12,

  flexDirection: "row",

  alignItems: "center",

  justifyContent: "space-between",

  borderBottomWidth: 4,

  borderBottomColor: COLORS.orange,

  marginBottom: 12,

},


schoolSection: {

  flexDirection:"row",

  alignItems:"center",

  flex:1,

},



logo: {

  width:55,

  height:55,

  borderRadius:28,

  borderWidth:2,

  borderColor:COLORS.orange,

  marginRight:10,

},



schoolDetails: {

 flex:1,

},



schoolName: {

 fontSize:14,

 fontWeight:"bold",

 color:COLORS.black,

 marginBottom:3,

},



schoolMotto: {

 fontSize:8,

 color:"#000000",

 marginBottom:2,

},



schoolAddress: {

 fontSize:7.5,

 color:"#000000",

},



secureBadge: {
backgroundColor: "#374151",
paddingVertical:7,
paddingHorizontal:10,
borderRadius:5,
},



secureBadgeText: {
color:COLORS.white,
fontSize:9,
fontWeight:"bold",
letterSpacing:1,
},



/* ============================================================
   TITLE
============================================================ */


titleBox: {

backgroundColor: "#D1D5DB",

 borderRadius:7,

 paddingVertical:8,

 paddingHorizontal:10,

 marginBottom:12,

},



title: {

 textAlign:"center",

 color:COLORS.black,

 fontSize:13,

 fontWeight:"bold",

 letterSpacing:.5,

},



subtitle: {

 textAlign:"center",

 color:COLORS.black,

 fontSize:8,

 marginTop:3,

 lineHeight:1.3,

},



/* ============================================================
   CONTENT
============================================================ */


content: {
 flexDirection:"column",
},



/* ============================================================
   PROFILE
============================================================ */


profileCard: {

 backgroundColor:COLORS.white,

 borderWidth:1,

 borderColor:COLORS.gray3,

 borderRadius:8,

 padding:10,

 alignItems:"center",

 marginBottom:12,

},



avatar: {

 width:95,

 height:95,

 borderRadius:48,

 borderWidth:2,

 borderColor:COLORS.orange,

 marginBottom:8,

},



studentName: {

 fontSize:13,

 fontWeight:"bold",

 textAlign:"center",

},



studentID: {

 marginTop:4,

 color:COLORS.orangeDark,

 fontSize:9,

 fontWeight:"bold",

},



verifiedBadge: {

 marginTop:8,

 backgroundColor:COLORS.greenLight,

 borderWidth:1,

 borderColor:COLORS.green,

 borderRadius:5,

 paddingVertical:4,

 paddingHorizontal:8,

},



verifiedText: {

 color:COLORS.green,

 fontWeight:"bold",

 fontSize:8,

},



/* ============================================================
   SECTIONS
============================================================ */


section: {

 backgroundColor:COLORS.white,

 borderWidth:1,

 borderColor:COLORS.gray3,

 borderRadius:8,

 overflow:"hidden",

 marginBottom:10,

},



sectionHeader: {

 backgroundColor:COLORS.black,

 borderLeftWidth:4,

 borderLeftColor:COLORS.orange,

 paddingVertical:6,

 paddingHorizontal:10,

},



sectionHeaderText: {

 color:COLORS.white,

 fontWeight:"bold",

 fontSize:9,

},



sectionBody: {

 padding:9,

},



row: {

 flexDirection:"row",

 paddingVertical:4,

 borderBottomWidth:.5,

 borderBottomColor:"#eeeeee",

},



label: {

 width:110,

 color:COLORS.gray,

 fontWeight:"bold",

 fontSize:8,

},



value: {

 flex:1,

 fontWeight:"bold",

 fontSize:8,

},



/* ============================================================
   CREDENTIALS
============================================================ */


credentialBox: {

 marginTop:8,

 backgroundColor:COLORS.orangeLight,

 borderWidth:1,

 borderColor:COLORS.orange,

 borderRadius:6,

 padding:8,

},



credentialTitle: {
 color:COLORS.black,
 fontSize:9,
 fontWeight:"bold",
 marginBottom:5,
},



username: {

 color:COLORS.blue,

 fontWeight:"bold",

 fontSize:9,

},



password: {

 color:COLORS.red,

 fontWeight:"bold",

 fontSize:10,

},



statusActive: {

 color:COLORS.green,

 fontWeight:"bold",

 fontSize:9,

},



warningText: {

 fontSize:7.5,

 color:COLORS.charcoal,

 lineHeight:1.4,

 marginTop:3,

},



/* ============================================================
 SECURITY
============================================================ */


securityBox: {

 backgroundColor:"#f8fafc",

 borderWidth:1,

 borderColor:COLORS.gray3,

 borderRadius:7,

 padding:8,

 marginTop:10,

},



securityTitle: {
color:COLORS.black,
fontSize:9,
fontWeight:"bold",
marginBottom:5,
},



securityItem: {
fontSize:7.5,
color:COLORS.charcoal,
lineHeight:1.4,
marginBottom:3,
},



/* ============================================================
 FOOTER
============================================================ */


footer: {

 marginTop:12,

 borderTopWidth:1,

 borderTopColor:COLORS.gray3,

 paddingTop:6,

 textAlign:"center",

 fontSize:7,

 color:COLORS.gray,

 lineHeight:1.4,

},


});
/* ============================================================
   STUDENT AUTHENTICATION PDF DOCUMENT
============================================================ */

const StudentAuthenticationPDF = ({ student }) => {

  const profileImage =
    student?.profile_image ||
    student?.student_admission_image ||
    defaultAvatar;


  return (

    <Document>

      <Page
        size="A4"
        orientation="portrait"
        style={styles.page}
        wrap={false}
      >


        {/* =====================================================
            HEADER
        ===================================================== */}

        <View style={styles.header}>


          <View style={styles.schoolSection}>


            <Image
              src={schoolLogo}
              style={styles.logo}
            />


            <View style={styles.schoolDetails}>


              <Text style={styles.schoolName}>
                Salvation In Christ School System - SICSS
              </Text>


              <Text style={styles.schoolMotto}>
                Learning Today • Leading Tomorrow
              </Text>


              <Text style={styles.schoolAddress}>
                Official Student Authentication &
                Secure Identity Verification
              </Text>

              <Text style={styles.schoolAddress}>
               Zazay Community, Paynesville City, Monrovia
              </Text>


            </View>


          </View>



          <View style={styles.secureBadge}>

            <Text style={styles.secureBadgeText}>
              SECURE
            </Text>

          </View>



        </View>




        {/* =====================================================
            DOCUMENT TITLE
        ===================================================== */}


        <View style={styles.titleBox}>


          <Text style={styles.title}>

            STUDENT AUTHENTICATION DOCUMENT

          </Text>



          <Text style={styles.subtitle}>

            This document confirms that the student
            below is officially registered in the
            school's secured management system.

          </Text>


        </View>





        {/* =====================================================
            STUDENT PROFILE
        ===================================================== */}


        <View style={styles.profileCard}>


          <Image

            src={profileImage}

            style={styles.avatar}

          />



          <Text style={styles.studentName}>

            {student?.full_name || "N/A"}

          </Text>




          <Text style={styles.studentID}>

            Student ID :
            {" "}
            {student?.admission_id || "N/A"}

          </Text>




          <View style={styles.verifiedBadge}>

            <Text style={styles.verifiedText}>

              ✓ VERIFIED STUDENT

            </Text>


          </View>



        </View>






        {/* =====================================================
            STUDENT INFORMATION
        ===================================================== */}



        <View style={styles.section}>


          <View style={styles.sectionHeader}>


            <Text style={styles.sectionHeaderText}>

              STUDENT INFORMATION

            </Text>


          </View>





          <View style={styles.sectionBody}>


            {[
              [
                "Full Name",
                student?.full_name
              ],

              [
                "Student ID",
                student?.admission_id
              ],

   

              [
                "Gender",
                student?.gender
              ],

              [
                "Class",
                student?.grade_class_name
              ],

              [
                "Academic Year",
                student?.current_academic_year
              ],

              [
                "Date Of Birth",
                student?.date_of_birth
              ],

              [
                "Parent/Guardian",
                student?.mother_name
              ],

              [
                "Parent/Guardian Phone",
                student?.parent_contact
              ],


            ].map(

              ([label,value],index)=>(


                <View
                  key={index}
                  style={styles.row}
                >


                  <Text style={styles.label}>

                    {label}

                  </Text>




                  <Text style={styles.value}>

                    {value || "N/A"}

                  </Text>



                </View>


              )


            )}



          </View>



        </View>






        {/* =====================================================
            PORTAL LOGIN INFORMATION
        ===================================================== */}



        <View style={styles.section}>


          <View style={styles.sectionHeader}>


            <Text style={styles.sectionHeaderText}>

              STUDENT PORTAL ACCESS

            </Text>


          </View>




          <View style={styles.sectionBody}>



            <View style={styles.row}>


              <Text style={styles.label}>

                Email:

              </Text>



              <Text style={styles.username}>

                {
                  student?.email ||
                  student?.admission_id ||
                  "N/A"
                }

              </Text>


            </View>





            <View style={styles.row}>


              <Text style={styles.label}>

                Initial Password

              </Text>




              <Text style={styles.password}>

                {
                  student?.initial_password ||
                  student?.password ||
                  "N/A"
                }

              </Text>


            </View>





            <View style={styles.row}>


              <Text style={styles.label}>

                Account Status

              </Text>




              <Text style={styles.statusActive}>

                ACTIVE

              </Text>



            </View>





            <View style={styles.credentialBox}>


              <Text style={styles.credentialTitle}>

                IMPORTANT SECURITY INFORMATION

              </Text>




              <Text style={styles.warningText}>

                • Login credentials belong only to the registered student.

              </Text>



              <Text style={styles.warningText}>

                • Do not share your password with unauthorized persons.

              </Text>




              <Text style={styles.warningText}>

                • Change your password after first login.

              </Text>




              <Text style={styles.warningText}>

                • Contact school administration if access is compromised.

              </Text>



            </View>



          </View>



        </View>
        {/* =====================================================
            SECURITY VERIFICATION NOTICE
        ===================================================== */}


        <View style={styles.securityBox}>


          <Text style={styles.securityTitle}>

            SECURITY NOTICE

          </Text>



          <Text style={styles.securityItem}>

            • This document is generated directly from
            the school's secured database system.

          </Text>



          <Text style={styles.securityItem}>

            • Any unauthorized editing, modification,
            or reproduction makes this document invalid.

          </Text>



          <Text style={styles.securityItem}>

            • The student's photograph and information
            must match official school records.

          </Text>



          <Text style={styles.securityItem}>

            • Verification is only accepted through
            the school administration office.

          </Text>



          <Text style={styles.securityItem}>

            • This document is confidential and intended
            for the registered student and authorized
            school officials only.

          </Text>



        </View>







        {/* =====================================================
            AUTHENTICATION AREA
        ===================================================== */}



        <View
          style={{
            flexDirection:"row",
            justifyContent:"space-between",
            alignItems:"center",
            marginTop:12,
          }}
        >



          {/* OFFICIAL STAMP */}

          <View
            style={{
              width:90,
              height:70,
              borderWidth:1,
              borderStyle:"dashed",
              borderColor:COLORS.gray2,
              borderRadius:6,
              justifyContent:"center",
              alignItems:"center",
            }}
          >


            <Text
              style={{
                fontSize:7,
                color:COLORS.gray,
                textAlign:"center",
              }}
            >

              SCHOOL{"\n"}
              OFFICIAL{"\n"}
              STAMP

            </Text>


          </View>






          {/* QR VERIFICATION */}

          <View
            style={{
              width:90,
              height:70,
              borderWidth:1,
              borderStyle:"dashed",
              borderColor:COLORS.gray2,
              borderRadius:6,
              justifyContent:"center",
              alignItems:"center",
            }}
          >


            <Text
              style={{
                fontSize:7,
                color:COLORS.gray,
                textAlign:"center",
              }}
            >

              QR CODE{"\n"}
              VERIFY

            </Text>


          </View>







          {/* SIGNATURE */}


          <View
            style={{
              flex:1,
              marginLeft:12,
            }}
          >


            <Text
              style={{
                fontSize:8,
                fontWeight:"bold",
                marginBottom:8,
              }}
            >

              Authorized Signature

            </Text>




            <View
              style={{
                borderBottomWidth:1,
                borderBottomColor:COLORS.gray,
                width:140,
                marginBottom:5,
              }}
            />




            <Text
              style={{
                fontSize:7,
                color:COLORS.gray,
              }}
            >

              Principal / Administrator

            </Text>



          </View>



        </View>








        {/* =====================================================
            FOOTER
        ===================================================== */}


        <Text style={styles.footer}>

          © {new Date().getFullYear()}
          {" "}
          Salvation Christ International School
          www.salvationinchristschoolsystem.com
          {" • "}
          Official Student Authentication Document
          {" • "}
          Confidential Record Generated Polu Integrated School Management System

        </Text>





      </Page>


    </Document>


  );

};







/* ============================================================
   SECURE PDF DOWNLOAD GENERATOR
============================================================ */


const Secure = ({ student }) => {


  useEffect(() => {


    if(!student) return;



    const generatePDF = async()=>{


      try{


        const blob = await pdf(

          <StudentAuthenticationPDF
            student={student}
          />

        ).toBlob();





        const fileName =
          `Secure_Student_Authentication_${
            student?.student_id ||
            "Student"
          }.pdf`;






        const url =
          URL.createObjectURL(blob);





        const link =
          document.createElement("a");




        link.href=url;

        link.download=fileName;



        document.body.appendChild(link);

        link.click();


        document.body.removeChild(link);




        URL.revokeObjectURL(url);




      }
      catch(error){


        console.error(
          "PDF Generation Error:",
          error
        );


      }



    };



    generatePDF();



  },[student]);





  return null;


};





export default Secure;